import type { TokenPair } from '@/lib/api/types'
import { refreshTransport } from '@/lib/env'

export type Session = {
  accessToken: string
  accessTokenExpiresAt: string | null
  refreshToken: string | null
}

let current: Session | null = null
const listeners = new Set<() => void>()

const notify = (): void => {
  for (const listener of listeners) {
    listener()
  }
}

export const readSession = (): Session | null => current

export const subscribeToSession = (listener: () => void): (() => void) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export const startSession = (tokens: TokenPair): Session => {
  const session: Session = {
    accessToken: tokens.accessToken ?? '',
    accessTokenExpiresAt: tokens.accessTokenExpiresAt ?? null,
    refreshToken: refreshTransport === 'cookie' ? null : (tokens.refreshToken ?? null),
  }

  current = session
  notify()

  return session
}

export const endSession = (): void => {
  current = null
  notify()
}

export const readAccessToken = (): string | null => current?.accessToken ?? null

export const readRefreshToken = (): string | null => current?.refreshToken ?? null

export const canRefresh = (): boolean =>
  refreshTransport === 'cookie' || (current !== null && current.refreshToken !== null)
